// extracted by mini-css-extract-plugin
export default {"tagsContainer":"tag-input_tagsContainer__ltcXp","hidden":"tag-input_hidden__rJQu1","inputContainer":"tag-input_inputContainer__EPETf","input":"tag-input_input__Qwae8"};